import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemoveKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRemoveKeyframe"><Path fillRule="evenodd" clipRule="evenodd" d="M1.08594 12.0001L12.0002 1.08594L22.9144 12.0001L12.0002 22.9144L1.08594 12.0001ZM9 11V13H15V11H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRemoveKeyframe;
